
export function validate_m (str) {

  var reg = new RegExp(/^[0-9]*$/);
  var res = reg.test(str);

  console.log("validate m : " + res)

  return res;
}


export function validate_k (str) {

  var reg = new RegExp(/^[0-9]*$/);
  var res = reg.test(str);

  console.log("validate k : " + res)

  return res;
}


export function validate_r (str) {

  var reg = new RegExp(/^[0-9]\.[0-9].*$|^[0-9]\.*$/);
  // var reg = new RegExp(/^[0-9]*$/);
  var res = reg.test(str);

  console.log("validate r=" + str + " : " + res )

  return res;
}

